import React, { useState } from 'react';
import AttendanceSetupTable from './AttendanceSetupTable';
import WeightageSetupTable from './WeightageSetupTable';
import LetterSetupTable from './LetterSetupTable';

const AppraisalSetupDisplay = () => {
    const [toggleState, setToggleState] = useState(2);

    return (
        <div className="table-css-white-background" style={{ padding: "10px" }}>
            <div className="bloc-tabss wfm-margin">
                <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-tabss"}
                    onClick={() => setToggleState(1)}
                >
                    Weightage Setup
                </button>
                <button
                    className={toggleState === 2 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-tabss"}
                    onClick={() => setToggleState(2)}
                >
                    Attendance Marking Setup
                </button>
                <button
                    className={toggleState === 3 ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-tabss"}
                    onClick={() => setToggleState(3)}
                >
                    Letter Marking Setup
                </button>
            </div>

            <div className="content-tabs mt-4">
                {toggleState === 1 ? <WeightageSetupTable /> : null}
                {toggleState === 2 ? <AttendanceSetupTable /> : null}
                {toggleState === 3 ? <LetterSetupTable /> : null}
            </div>
        </div>
    );
};

export default AppraisalSetupDisplay;
